import { render, staticRenderFns } from "./mediaGallery.vue?vue&type=template&id=579ca51c"
import script from "./mediaGallery.vue?vue&type=script&lang=js"
export * from "./mediaGallery.vue?vue&type=script&lang=js"
import style0 from "./mediaGallery.vue?vue&type=style&index=0&id=579ca51c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports